import Parser from 'html-react-parser';
import cx from 'classnames';

export default function InteractivePart({ part, selectPart, isSelected = false }) {
    const oldText = formatTextValue(part.oldText);
    const newText = formatTextValue(part.newText);

    if (part.processed) {
        return (
            <>
                {!part.accepted && oldText !== undefined && oldText !== '' && (
                    <span className="part-processed">{Parser(oldText)}</span>
                )}

                {part.accepted && newText !== undefined && newText !== '' && (
                    <span className="part-processed">{Parser(newText)}</span>
                )}
            </>
        );
    }

    return (
        <span
            className={cx('part', {
                selected: isSelected,
            })}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                selectPart();
            }}
        >
            {oldText !== undefined && oldText !== '' && <del>{Parser(oldText)}</del>}
            {newText !== undefined && newText !== '' && <ins>{Parser(newText)}</ins>}
        </span>
    );

    function formatTextValue(text) {
        if (text === undefined) {
            return undefined;
        }

        // If empty space, return 'nbsp' chars to fix empty span
        if (text.length === 1 && text === ' ') {
            return '&nbsp;&nbsp;';
        }

        return text;
    }
}
